import { useContext } from 'react'
import styled from 'styled-components'
import PredictionTable from '@app.feature/exam/gsat2024-2/components/Table/PredictionTable'
import { TableColumnType } from '@app.feature/exam/gsat2024-2/components/Table/PredictionTableHead'
import { PredictionOfPassedContainerContext } from '@app.feature/exam/gsat2024-2/context/PredictionOfPassedContainerContext'
import { parseTestResultDate } from '../../module/testResult.module'
import SpredScoreInfoTableColumns from './components/SpredScoreInfoTableColumns'
import { findScrorePosition } from './module/findTooltipArea.module'

type SpreadScoreInfoColumnItem = {
  name: string
  value: number
  isAverageScore?: boolean
  isMyScore?: boolean
}

const SpreadScoreInfoArticleDesktop = () => {
  const {
    examReserveInformation,
    examGradingResultDistribution,
    examGradingResultDistributionSameInfo,
    examGradingResultData,
    examTestsData,
    examGradingRankFromTestRate,
    examGradingRankOfSameInfoFromTestRate,
  } = useContext(PredictionOfPassedContainerContext)

  const examDate = parseTestResultDate({
    dateList: examTestsData || [],
    testId: examReserveInformation?.examTest.id || '',
    formatType: 'slash',
  })

  const { averageScoreIndex, myScoreIndex, sameInfoAverageScoreIndex } =
    findScrorePosition({
      myScore: examGradingResultData?.viewerResult.correctCount || 0,
      averageScore: examGradingResultData?.averageScore.correctCount || 0,
      smaeInfoAverageScore:
        examGradingResultData?.sameInfoAverage.correctCount || 0,
    })

  const COLUMNS: TableColumnType<SpreadScoreInfoColumnItem>[] = [
    { id: '0', label: '맞은 문항 수(개)', dataIndex: 'name' },
    {
      id: '1',
      label: '응시자 비율(%)',
      dataIndex: 'value',
      render: (data) => {
        const tooltipType = data.isMyScore
          ? 'myScore'
          : data.isAverageScore
          ? 'average'
          : false

        return (
          <SpredScoreInfoTableColumns
            tooltipType={tooltipType}
            value={data.value}
          />
        )
      },
    },
  ]

  const spreadScoreInfoAllUser: Array<SpreadScoreInfoColumnItem> =
    examGradingResultDistribution?.map((item, index) => {
      return {
        name: item.range,
        value: item.rate,
        isMyScore: index === myScoreIndex,
        isAverageScore: index === averageScoreIndex,
      }
    }) || []

  const spreadScoreInfoSameInfo =
    examGradingResultDistributionSameInfo?.map((item, index) => {
      return {
        name: item.range,
        value: item.rate,
        isMyScore: index === myScoreIndex,
        isAverageScore: index === sameInfoAverageScoreIndex,
      }
    }) || []

  return (
    <StyledWrapper>
      <div className="table-layout">
        <label>
          {examDate} 전체 응시생 중&nbsp;
          <span>
            상위&nbsp;
            {examGradingRankFromTestRate}%
          </span>
        </label>
        <PredictionTable<SpreadScoreInfoColumnItem>
          tableColumns={COLUMNS}
          tableDataList={spreadScoreInfoAllUser}
        />
      </div>
      <div className="table-layout">
        <label>
          {examDate} 동일 사업부/직무 응시생 중&nbsp;
          <span>
            상위&nbsp;
            {examGradingRankOfSameInfoFromTestRate}%
          </span>
        </label>
        <PredictionTable
          tableColumns={COLUMNS}
          tableDataList={spreadScoreInfoSameInfo}
        />
      </div>
    </StyledWrapper>
  )
}

export default SpreadScoreInfoArticleDesktop

const StyledWrapper = styled.article`
  padding: 28px;
  border-radius: 10px;
  background-color: #fff;
  display: flex;
  flex-direction: column;
  gap: 36px;

  > .table-layout {
    > label {
      font-size: 16px;
      font-weight: bold;
      letter-spacing: -0.64px;
      color: #333;
      display: flex;
      align-items: baseline;
      margin-bottom: 16px;

      > span {
        color: #004eff;
      }
    }
  }
`
